import React, { useEffect } from "react";
import { Link, ScrollRestoration } from 'react-router-dom';
import '../App.css';
//import Caro from "/Users/lucyking/Projects/portfolio/lk-portfolio/src/components/Caro"
import Caro from "../components/Caro";
import ReactPlayer from 'react-player';
import ReactGoogleSlides from "react-google-slides";
            
// {title, desc, skillList, url, github, photo1, photo2, photo3}
export default function ProjectStudy({proj, onClose}){

    const {title, long_desc, skillList, url, github, images, demoVid, slidesUrl} = proj;
    console.log("proj: ", title);

    const closeIcon = <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="40.000000pt" height="40.000000pt" fill="#6C584C" viewBox="0 0 200.000000 200.000000"
    preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        stroke="none">
        <path d="M518 1588 c-9 -7 -19 -24 -23 -37 -6 -20 21 -51 231 -262 l238 -239
        -238 -239 c-210 -211 -237 -242 -231 -262 9 -30 32 -49 59 -49 14 0 99 78 251
        230 126 127 234 230 240 230 6 0 114 -103 240 -230 164 -164 236 -230 252
        -230 27 0 63 33 63 57 0 10 -107 125 -237 255 l-238 238 239 239 c210 211 237
        242 231 262 -9 30 -32 49 -61 49 -16 0 -89 -67 -250 -230 -125 -126 -232 -230
        -238 -230 -6 0 -115 104 -241 230 -231 231 -251 246 -287 218z"/>
        </g>
   </svg>

    return (
        <div className="study-content">
            <div >
                {/* <Link to="/" replace ="True"> <button class="back-button"> Home </button> </Link> */}
                {/* REPLACE WITH X ICON */}
                <div className="back-button" onClick={onClose}> {closeIcon} </div> 
                <div className="proj-title">{title}</div>
            </div>

            <div className="button-row">
                {/* { title !== "Auction Alchemy" && <button><a href={url}> View the site </a></button> } */}
                { github && <button> <a href={github} target="_blank"> Github Repo </a></button>}
                { url && <button> <a href={url} target="_blank"> View Site </a></button> }
            </div>
            

            <div className="skill-list">
                {skillList.map((str, index) => (
                    <div className="skill" key={str}>
                    {str}
                    </div>
                ))}
            </div>

            {/* demo vid */}
            { demoVid &&
                <ReactPlayer playing="true" controls="true" style={{ width: '100%', padding: '20px 0px'}} url={demoVid} width='100%' height='100%'/> 
            }

            {/* example images if don't have demo vid */}
            { !demoVid && images.length > 0 && 
                <Caro images={images} />
            }
            
            <div className="description">
                {long_desc}
            </div>                
                
            {/* slide deck */}
            { slidesUrl &&
                <div style={{width: '100%'}}>
                    {/* from https://github.com/ajhenry/react-google-slides?tab=readme-ov-file */}
                    <h2 style={{padding: '0px 0px 10px 0px'}}> Intern Demo Day Presentation: </h2>
                    <ReactGoogleSlides
                        width='100%'
                        slidesLink={slidesUrl}
                        slideDuration={5}
                        position={0}
                        showControls={'True'}
                        loop
                    />  
                </div>
            }

        </div>
    );

}             